function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import { createClient, queryProductByHandle, mutateCreateCheckout, mutateCreateCart } from '../../storefrontApi';
import { prefixedLogger } from '../../utils';
import { mutateUpdateCheckoutShippingAddress, queryCheckout } from '../../storefrontApi/queries/checkout';
import { queryCart } from '../../storefrontApi/queries/cart';
var logPrefix = '[StorefrontApi]';
var logDebug = prefixedLogger(logPrefix);
var logError = prefixedLogger(logPrefix, console.error);
/**
 * @typedef {Object} UseStorefrontApiResult
 * @property {(function(handle: string): Promise<*>)} getProductByHandle
 * @property {ApolloClient} client
 * @property {(function(input: CheckoutInput): Promise<{ id: string, webUrl: string }>)} createCheckout
 * @property {(function(input: CartInput): Promise<{ id: string, checkoutUrl: string }>)} createCart
 * @property {boolean} loadingShippingRates
 * @property {Array.<ShippingRate>|null} availableShippingRates
 */

/**
 *
 * @param accessToken
 * @param shopDomain
 * @param {string|null} [checkoutId]
 * @param {string|null} [cartId]
 * @param {MailingAddressInput} shippingAddress
 * @returns {UseStorefrontApiResult}
 */

export function useStorefrontApi(accessToken, shopDomain) {
  var checkoutId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var cartId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var shippingAddress = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  /** @type MutableRefObject<ApolloClient | null> */
  var clientRef = useRef(null);
  /** @type  [boolean, Dispatch<SetStateAction<boolean>>] */
  // eslint-disable-next-line no-unused-vars

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShippingCalcStale = _useState2[0],
      setIsShippingCalcStale = _useState2[1];
  /** @type  [boolean, Dispatch<SetStateAction<boolean>>] */


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loadingShippingRates = _useState4[0],
      setLoadingShippingRates = _useState4[1];
  /** @type  [Array.<ShippingRate> | null, Dispatch<SetStateAction<boolean>>] */


  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      availableShippingRates = _useState6[0],
      setAvailableShippingRates = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      cart = _useState8[0],
      setCart = _useState8[1];
  /** @type MutableRefObject<number | null> */


  var shippingRatesPollingRef = useRef(null);

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      errors = _useState10[0],
      setErrors = _useState10[1];

  var _ref = shippingAddress || {},
      shippingFirstName = _ref.firstName,
      shippingLastName = _ref.lastName,
      shippingAddress1 = _ref.address1,
      shippingCity = _ref.city,
      shippingProvince = _ref.province,
      shippingZip = _ref.zip,
      shippingCountry = _ref.country;

  var debouncedFetchAvailableShippingRates = useMemo(function () {
    return debounce(function (id) {
      // clear any ongoing shipping rate polling
      if (shippingRatesPollingRef.current) {
        clearInterval(shippingRatesPollingRef.current);
        shippingRatesPollingRef.current = null;
      }

      setLoadingShippingRates(true);

      function onShippingRatesAvailable(rates) {
        logDebug('Available shipping rates retrieved', {
          availableShippingRates: rates
        });
        var shippingRates = (rates.shippingRates || []).map(function (rate) {
          // !!!!!! HACK: the storefront API doesn't return shipping rates with discounts applied, so there's no way to'
          // display a shipping option that's discounted by Shopify scripts.  For now, we assume standard shipping is always
          // FREE for storefront api (i.e. lander) purchases.
          return _objectSpread(_objectSpread({}, rate), {}, {
            discount: rate.title.startsWith('Standard') ? {
              amount: rate.priceV2.amount
            } : null
          });
        });

        if (shippingRates.length > 0) {
          setErrors([]);
        }

        setAvailableShippingRates(shippingRates);
        setLoadingShippingRates(false);
      }

      function pollForShippingRates() {
        return _pollForShippingRates.apply(this, arguments);
      } // poll for shipping rates: always wait rather than using the rates returned after the
      // original address update, as it takes Shopify time to respond to a change in shipping address


      function _pollForShippingRates() {
        _pollForShippingRates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var updatedCheckout, _ref2, _ref2$availableShippi, availableRates;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  if (shippingRatesPollingRef.current) {
                    clearTimeout(shippingRatesPollingRef.current);
                  }

                  logDebug('Polling for available shipping rates...');
                  _context.next = 5;
                  return queryCheckout(clientRef.current, id);

                case 5:
                  updatedCheckout = _context.sent;
                  _ref2 = updatedCheckout || {}, _ref2$availableShippi = _ref2.availableShippingRates, availableRates = _ref2$availableShippi === void 0 ? {} : _ref2$availableShippi;

                  if (availableRates && availableRates.ready) {
                    shippingRatesPollingRef.current = null;
                    onShippingRatesAvailable(availableRates);
                  } else {
                    shippingRatesPollingRef.current = setTimeout(pollForShippingRates, 1000);
                  }

                  _context.next = 14;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](0);
                  logError('Failed polling for shipping rates', {
                    err: _context.t0
                  });
                  setLoadingShippingRates(false);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 10]]);
        }));
        return _pollForShippingRates.apply(this, arguments);
      }

      shippingRatesPollingRef.current = setTimeout(pollForShippingRates, 100);
      logDebug('Started polling for available shipping rates');
    }, 200, {
      trailing: true
    });
  }, []);
  useEffect(function () {
    logDebug('Checkout id/address change', {
      checkoutId: checkoutId,
      shippingFirstName: shippingFirstName,
      shippingLastName: shippingLastName,
      shippingAddress1: shippingAddress1,
      shippingCity: shippingCity,
      shippingProvince: shippingProvince,
      shippingZip: shippingZip,
      shippingCountry: shippingCountry
    });
    setErrors([]);
    setAvailableShippingRates([]); // only calculate rates if we have a checkout id (using checkout workflow)

    if (checkoutId && shippingCity && shippingProvince && shippingZip && shippingCountry) {
      var partialShippingAddress = {
        firstName: shippingFirstName,
        lastName: shippingLastName,
        address1: shippingAddress1,
        city: shippingCity,
        province: shippingProvince,
        zip: shippingZip,
        country: shippingCountry
      };
      logDebug('Updating shipping address...', {
        shippingAddress: partialShippingAddress
      }); // update checkout shipping address.  Only a partial address is required to calculate shipping rates

      mutateUpdateCheckoutShippingAddress(clientRef.current, checkoutId, partialShippingAddress).then(function (result) {
        var updatedCheckout = result.checkout,
            checkoutUserErrors = result.checkoutUserErrors;
        logDebug('Shipping address updated', {
          updatedCheckout: updatedCheckout,
          checkoutUserErrors: checkoutUserErrors
        });
        checkoutUserErrors = checkoutUserErrors || [];

        if (checkoutUserErrors.length > 0) {
          setAvailableShippingRates([]);
          setErrors(checkoutUserErrors.map(function (err) {
            return err.message;
          }));
          setLoadingShippingRates(false);
        } else {
          debouncedFetchAvailableShippingRates(checkoutId);
        } // because eslint sez so


        return true;
      })["catch"](function (err) {
        return logError('Failed updating checkout shipping address', err);
      });
    }
  }, [checkoutId, shippingFirstName, shippingLastName, shippingAddress1, shippingCity, shippingProvince, shippingZip, shippingCountry, debouncedFetchAvailableShippingRates]);
  useEffect(function () {
    return function () {
      debouncedFetchAvailableShippingRates.cancel();
    };
  }, []);
  useEffect(function () {
    clientRef.current = createClient(shopDomain, accessToken);
  }, [accessToken, shopDomain]);
  useEffect(function () {
    function fetchCheckout() {
      return _fetchCheckout.apply(this, arguments);
    }

    function _fetchCheckout() {
      _fetchCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var queryResult, _ref3, fetched, checkoutUserErrors;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return queryCheckout(clientRef.current, checkoutId);

              case 2:
                queryResult = _context2.sent;
                _ref3 = queryResult || {}, fetched = _ref3.checkout, checkoutUserErrors = _ref3.checkoutUserErrors;
                logDebug('Checkout fetched', {
                  checkout: fetched,
                  checkoutUserErrors: checkoutUserErrors
                }); // eslint-disable-next-line no-warning-comments
                // TODO: set cart from fetched checkout

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _fetchCheckout.apply(this, arguments);
    }

    function fetchCart() {
      return _fetchCart.apply(this, arguments);
    }

    function _fetchCart() {
      _fetchCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var fetchedCart, _ref4, _ref4$lines, _ref4$lines$edges, lines, cartItems;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return queryCart(clientRef.current, cartId);

              case 2:
                fetchedCart = _context3.sent;
                logDebug('Cart fetched', {
                  cart: fetchedCart
                });
                _ref4 = fetchedCart || {}, _ref4$lines = _ref4.lines;
                _ref4$lines = _ref4$lines === void 0 ? {} : _ref4$lines;
                _ref4$lines$edges = _ref4$lines.edges, lines = _ref4$lines$edges === void 0 ? [] : _ref4$lines$edges;
                cartItems = lines.map(function (line) {
                  var _line$node = line.node,
                      id = _line$node.id,
                      _line$node$merchandis = _line$node.merchandise;
                  _line$node$merchandis = _line$node$merchandis === void 0 ? {} : _line$node$merchandis;
                  var variantId = _line$node$merchandis.id,
                      quantity = _line$node$merchandis.quantity,
                      sku = _line$node$merchandis.sku,
                      requiresShipping = _line$node$merchandis.requiresShipping,
                      _line$node$merchandis2 = _line$node$merchandis.sellingPlanAllocations.nodes,
                      sellingPlanAllocations = _line$node$merchandis2 === void 0 ? [] : _line$node$merchandis2;
                  return {
                    id: id,
                    variantId: variantId,
                    quantity: quantity,
                    sku: sku,
                    requiresShipping: requiresShipping,
                    hasSellingPlan: sellingPlanAllocations.length > 0,
                    sellingPlanAllocations: sellingPlanAllocations
                  };
                });
                logDebug('Setting cart items', {
                  workflow: 'Cart',
                  items: cartItems
                });
                setCart({
                  items: cartItems
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _fetchCart.apply(this, arguments);
    }

    if (checkoutId) {
      fetchCheckout()["catch"](function (err) {
        return logError('Error fetching checkout', err);
      });
    } else if (cartId) {
      fetchCart()["catch"](function (err) {
        return logError('Failed fetching cart', err);
      });
    }
  }, [checkoutId, cartId]);
  /**
   * @type {function(input: CheckoutInput): Promise<{id: string }>}
   */

  var createCheckout = useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(input) {
      var co;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(clientRef.current == null)) {
                _context4.next = 2;
                break;
              }

              throw new Error('Client is not initialized');

            case 2:
              _context4.next = 4;
              return mutateCreateCheckout(clientRef.current, input);

            case 4:
              co = _context4.sent;
              console.debug('checkout created', {
                checkout: co
              });
              return _context4.abrupt("return", co);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), []);
  /**
   * @type {function(input: CartInput): Promise<{id: string, checkoutUrl: string}>}
   */

  var createCart = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(input) {
      var newCart;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(clientRef.current == null)) {
                _context5.next = 2;
                break;
              }

              throw new Error('Client is not initialized');

            case 2:
              _context5.next = 4;
              return mutateCreateCart(clientRef.current, input);

            case 4:
              newCart = _context5.sent;
              console.debug('cart created', JSON.stringify(newCart));
              return _context5.abrupt("return", newCart);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }(), []);
  var getProductByHandle = useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(productHandle) {
      var product;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(clientRef.current == null)) {
                _context6.next = 2;
                break;
              }

              throw new Error('Client is not initialized');

            case 2:
              _context6.next = 4;
              return queryProductByHandle(clientRef.current, productHandle);

            case 4:
              product = _context6.sent;
              console.debug('Product query result', {
                product: product
              });
              return _context6.abrupt("return", product);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x3) {
      return _ref7.apply(this, arguments);
    };
  }(), []);
  return {
    client: clientRef.current,
    createCart: createCart,
    createCheckout: createCheckout,
    getProductByHandle: getProductByHandle,
    loadingShippingRates: loadingShippingRates,
    availableShippingRates: availableShippingRates,
    cart: cart,
    errors: errors
  };
}